import React, { useEffect, useState } from "react";
import { SmokingsGrisesContainer } from "./styles";
import { BackToTop, Footer, NavItem, NavMenu, ToggleButton } from "../../Inicio/styles";
import { useLocation, useNavigate } from "react-router-dom";
import { ModelCard, ModelGrid, ModelImage, ModelInfo, ModelName } from "../../Trajes/Negros/styles";

const Sgrises = () => {
    const [collapsed, setCollapsed] = useState(false)
    const location = useLocation();
    const navigate = useNavigate();

    const [showButton, setShowButton] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if(window.scrollY > 300) {
                setShowButton(true)
            }else {
                setShowButton(false)
            }
        }

        window.addEventListener("scroll", handleScroll)
        return () => window.removeEventListener("scroll", handleScroll)

    }, []);

    const scrollToTop = () => {
        window.scroll({
            top: 0,
            behavior: "smooth"
        })
    };

    useEffect(() => {
                if(collapsed) {
                    document.body.style.overflow = "hidden";
                } else {
                    document.body.style.overflow = "auto";
                }
        
                return () => {
                    document.body.style.overflow = "auto";
                };
            }, [collapsed])
    

    return(
        <>
            <SmokingsGrisesContainer>
                <p>Smokings grises</p>
                <ToggleButton collapsed={collapsed} onClick={() => setCollapsed(!collapsed)}>
                    {collapsed ? "✕" : "☰"}
                </ToggleButton>

                <NavMenu collapsed={collapsed}>
                    <NavItem
                        active = {location.pathname === "/"}
                        onClick={() => navigate("/")}
                    >
                        Inicio
                    </NavItem>

                    <NavItem
                        active = {location.pathname === "/trajes"}
                        onClick={() => navigate("/trajes")}
                    >
                        Trajes
                    </NavItem>

                    <NavItem
                        active = {location.pathname.startsWith("/smokings")}
                        onClick={() => navigate("/smokings")}
                    >
                        Smokings
                    </NavItem>

                    <NavItem
                        active = {location.pathname === "/togas"}
                        onClick={() => navigate("/togas")}
                    >
                        Togas
                    </NavItem>
                    <NavItem>
                        <a
                            href="/catalogo-trajes"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Catálogo
                        </a>
                    </NavItem>
                    <NavItem><a href="https://wa.me/5213311407070" target="_blank" rel="noopener noreferrer">Contacto</a></NavItem>
                </NavMenu>
            </SmokingsGrisesContainer>
            <ModelGrid>
                <ModelCard>
                    <ModelImage 
                        src="/img/Londres.jpg" alt="Londres"
                        onClick={() => navigate("/smokings/grises/londres")}
                    />
                    <ModelInfo>
                        <ModelName>Londres</ModelName>
                    </ModelInfo>
                </ModelCard>

                <ModelCard>
                    <ModelImage 
                        src="/img/Zurich-smk.jpg" alt="Zurich smoking"
                        onClick={() => navigate("/smokings/grises/zurichs")}    
                    />
                    <ModelInfo>
                        <ModelName>Zurich smoking</ModelName>
                    </ModelInfo>
                </ModelCard>
            </ModelGrid>
            <Footer>
                <p>Eleganza Sartoriale</p>
                <p>Guadalajara, Jalisco</p>
                <div>
                    <a href="https://www.instagram.com/renta_de_trajes_mr?utm_source=qr&igsh=MW9pb2VwMnRmeW8zaw==">Intagram</a>
                    <a href="https://www.facebook.com/share/14WVJRCc3W4/">Facebook</a>
                    <a href="https://www.tiktok.com/@rentadetrajesmr?_r=1&_t=ZS-95BqJJ1lF7X">Tik Tok</a>
                </div>
                <div>
                    <p>© 2026 Renta de Trajes MR. Todos los derechos reservados.</p>
                </div>
            </Footer>
            {showButton && (
                <BackToTop onClick={scrollToTop}>
                    ▲
                </BackToTop>
            )}
        </>
    )
};

export default Sgrises;